/**
 * Validation utility functions
 */

/**
 * Validates email format
 */
export const validateEmail = (email) => {
  if (!email) return { valid: false, message: 'Email is required' };
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { valid: false, message: 'Please enter a valid email address' };
  }
  
  return { valid: true };
};

/**
 * Validates mobile number based on country
 * @param {string} mobile - Mobile number
 * @param {string} country - Country name or code
 */
export const validateMobile = (mobile, country) => {
  if (!mobile) return { valid: false, message: 'Mobile number is required' };
  
  // Remove any spaces or special characters except digits
  const cleanedMobile = mobile.replace(/\D/g, '');
  
  // Country-specific validation
  const countryLower = (country || '').toLowerCase();
  if (countryLower === 'india' || countryLower === '+91' || country === '+91' || !country) {
    // India: exactly 10 digits (default if country not specified)
    if (cleanedMobile.length !== 10) {
      return { valid: false, message: 'Indian mobile number must be exactly 10 digits' };
    }
    // Check if starts with valid Indian mobile prefix (6-9)
    if (!/^[6-9]/.test(cleanedMobile)) {
      return { valid: false, message: 'Invalid Indian mobile number format (must start with 6-9)' };
    }
  } else {
    // Generic validation for other countries (minimum 7, maximum 15 digits)
    if (cleanedMobile.length < 7 || cleanedMobile.length > 15) {
      return { valid: false, message: 'Mobile number must be between 7 and 15 digits' };
    }
  }
  
  return { valid: true, cleanedValue: cleanedMobile };
};

/**
 * Validates required field
 */
export const validateRequired = (value, fieldName) => {
  if (!value || (typeof value === 'string' && value.trim() === '')) {
    return { valid: false, message: `${fieldName} is required` };
  }
  return { valid: true };
};

